import { removeToken } from '@/utils/cookies';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AccountLogin from './components/AccountLogin';
import LoginTypeTabs from './components/LoginTypeTabs';
import PhoneNoLogin from './components/PhoneNoLogin';
import style from './index.less';

function Login() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [loginType, setLoginType] = useState(params.get('type') || 'account');
  const [chainModalVisible, setChainModalVisible] = useState(false);

  useEffect(() => {
    removeToken();
  }, []);
  const onSelectLoginType = (type: string) => {
    setLoginType(type);
  };
  const onSelectChain = () => {
    setChainModalVisible(true);
  };
  const onSelectedChain = () => {
    navigate('/');
  };
  return (
    <section className={style.loginPage}>
      <div className={style.loginAm} />

      <div className={style.loginBody}>
        <div className={style.left}>
          <div className={style.logo} />
          <div className={style.bb}>本平台仅为广州中康科技数字有限公司系统管理平台，仅提供予内部员工使用。</div>
          <div className={style.bb}>
            <a style={{ color: '#87ddce' }} href="https://beian.miit.gov.cn/">
              粤ICP备2022073478号
            </a>{' '}
            Copyright 2008 - 2022 Sinohealth, All Rights Reserved
            <br />
          </div>
        </div>
        <div className={style.right}>
          <LoginTypeTabs active={loginType} onChange={onSelectLoginType} />
          {loginType === 'account' ? (
            <AccountLogin onSelectChain={onSelectChain} />
          ) : (
            <PhoneNoLogin onSelectChain={onSelectChain} />
          )}
        </div>
      </div>

    </section>
  );
}

export default Login;
